<div class="px-4 py-3">
  <div class="px-2 py-1">
    1. Download the CSV from the CDS Grafana.
  </div>

  <div class="px-2 py-1" fxLayout="row" fxLayoutAlign="space-between center">
    <div>
      2. Please select the CSV file downloaded from the CDS System
      <input
        #fileImportInput
        class="px-2"
        type="file"
        name="datasource_upload"
        id="datasource_upload"
        accept=".csv"
        ngf-max-size="20MB"
        fd-input
        (change)="fileChangeListener($event)"
      />
    </div>
    <button style="border-radius: 0.25em !important;" mat-raised-button color="primary" *ngIf="csvImport" (click)="clear()">Clear</button>
  </div>
  <div class="px-2 py-1">
    3. Click the upload button at the bottom of the page.
  </div>
  <div class="px-2 py-1">
    4. ABA files will be generated and saved. Download them from the list below.
  </div>
  <div class="px-2 py-1">
    5. Upload the ABA file to your bank.
  </div>
</div>


<div class="px-4 pb-2">
  <mat-divider></mat-divider>
</div>

<div *ngIf="displayLoading" class="px-4 py-2">
  <div class="mat-h2">Generating ABA files now!</div>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>


<div *ngIf="csvImport && !displayLoading" class="px-3 py-3">
  <span>Total rows in selected file: {{ rowCount }}</span>
</div>

<div *ngIf="!displayLoading">
  <div class="csvTable py-2">
    <table>
      <thead>
      <tr>
        <th class="px-2 py-1" *ngFor="let item of csvHeaders">{{ item }}</th>
      </tr>
      </thead>

      <tbody>
      <tr *ngFor="let element of csvRecords; let i = index">
        <td>{{ csvRecords[i][csvHeaders[0]] }}</td>
        <td>{{ csvRecords[i][csvHeaders[1]] }}</td>
        <td>{{ csvRecords[i][csvHeaders[2]] }}</td>
        <td>{{ csvRecords[i][csvHeaders[3]] }}</td>
        <td>{{ csvRecords[i][csvHeaders[4]] }}</td>
        <td>{{ csvRecords[i][csvHeaders[5]] }}</td>
      </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="csvImport" class="px-3 py-3">
    <button
      mat-raised-button
      id="save"
      class="d-block {{ this._style }}-small {{ this._style }}-primary mt-4"
      (click)="upload()"
      data-cy="upload"
    >
      Upload
    </button>
  </div>
</div>

<!-- ABA Files Download Section -->
<div class="px-4 py-3">
  <mat-divider></mat-divider>
</div>

<div class="px-4 py-2">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <span class="mat-h3 mb-0">ABA Files</span>
    <button mat-icon-button (click)="loadABAFiles()" [disabled]="loadingABAFiles" matTooltip="Refresh">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <div *ngIf="loadingABAFiles" class="py-2">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <div *ngIf="!loadingABAFiles && abaFolders.length === 0" class="py-2 text-muted">
    No ABA files found. Upload a CSV to generate ABA files.
  </div>

  <mat-accordion *ngIf="!loadingABAFiles && abaFolders.length > 0">
    <mat-expansion-panel *ngFor="let folder of abaFolders" [expanded]="folder.csvFolder === latestFolder">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ folder.csvFolder }}
        </mat-panel-title>
        <mat-panel-description>
          {{ folder.files.length }} file(s)
        </mat-panel-description>
      </mat-expansion-panel-header>

      <table class="aba-files-table">
        <thead>
          <tr>
            <th>File</th>
            <th>Records</th>
            <th>Amount</th>
            <th>Generated</th>
            <th>Download</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let file of folder.files">
            <td>{{ file.fileName }}</td>
            <td>{{ file.metadata?.recordCount || '-' }}</td>
            <td>{{ file.metadata?.totalAmount ? ('$' + (file.metadata.totalAmount / 100).toFixed(2)) : '-' }}</td>
            <td>{{ file.metadata?.generatedAt ? (file.metadata.generatedAt | date:'yyyy-MM-dd HH:mm') : (file.lastModified | date:'yyyy-MM-dd HH:mm') }}</td>
            <td>
              <a [href]="file.downloadUrl" target="_blank" mat-icon-button matTooltip="Download">
                <mat-icon>download</mat-icon>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </mat-expansion-panel>
  </mat-accordion>
</div>
